import { render, staticRenderFns } from "./CustomerITRQ.vue?vue&type=template&id=3c845a40&scoped=true&"
import script from "./CustomerITRQ.vue?vue&type=script&lang=ts&"
export * from "./CustomerITRQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c845a40",
  null
  
)

export default component.exports